import { useState, useEffect, useReducer } from "react";
import axios from "axios";

const fetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return {
        ...state,
        loading: true,
        error: false,
      };
    case "FETCH_SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case "FETCH_FAILURE":
      return {
        ...state,
        loading: false,
        error: true,
        data: action.payload,
      };
    default:
      throw new Error();
  }
};
const baseApiEndpoint = process.env.REACT_APP_API_URL;

export const useFetch = (initialParams) => {
  const token = localStorage.getItem("login") ?? null;

  axios.defaults.headers.common["Authorization"] = token;

  const [params, setParams] = useState(initialParams); // {method, url, data}
  const [state, dispatch] = useReducer(fetchReducer, {
    loading: false,
    error: false,
    data: initialParams && initialParams.data,
  });

  const fetchData = async () => {
    dispatch({ type: "FETCH_INIT" });
    await axios({
      method: params.method.toLowerCase(),
      url: baseApiEndpoint + params.url,
      headers: params.headers,
      ...(params.data && params.method === "get" ? { params: params.data } : { data: params.data }),
    })
      .then((result) => {
        dispatch({ type: "FETCH_SUCCESS", payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: "FETCH_FAILURE", payload: err });
      });
  };

  useEffect(() => {
    if (params) fetchData();
  }, [params]); // eslint-disable-line

  return [state, setParams];
};
